import { render, staticRenderFns } from "./action_button.vue?vue&type=template&id=528dc890&scoped=true&lang=html&"
import script from "./action_button.vue?vue&type=script&lang=js&"
export * from "./action_button.vue?vue&type=script&lang=js&"
import style0 from "./action_button.vue?vue&type=style&index=0&id=528dc890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528dc890",
  null
  
)

export default component.exports